module.exports = __webpack_public_path__ + "static/media/shopping-cart-alt.f54572b4.svg";